<template>
	<section v-if="application">
		<Header
			absolute
			:share="!application.isOwner || !application.isSeller"
			:shareTitle="`Veja ${application?.name}`"
			:shareText="`Comece a aproveitar os beneficios em ${application?.name} agora!`"
		/>
		<Button
			v-if="application.isOwner || application.isSeller"
			class="absolute !p-0 rounded-full top-6 right-4 w-12 h-12 items-center"
			:href="`/applications/${application._id}/admin`"
			variant="tertiary"
		>
			<span class="fi fi-br-menu-burger text-2xl flex"></span>
		</Button>
		<ApplicationHeader :application="application" :userBalance="application.balance || 0" />
		<ProductContainer :application="application" :userBalance="application.balance || 0" />
	</section>
</template>

<script setup lang="ts">
const route = useRoute()
const idOrSlug = route.params.applicationId

const application = ref<IApplication | undefined>(undefined)

application.value = await useApi(`/applications/${idOrSlug}`)

if (!application.value) {
	await navigateTo('/404')
}

definePageMeta({
	layout: 'authenticated',
	middleware: ['authenticate-user'],
})

useHead({
	title: `Veja os produtos e recompensas da ${application.value?.name}`,
	meta: [
		{
			name: 'description',
			content: `Confira os produtos e recompensas disponíveis na loja ${application.value?.name}`,
		},
	],
})
</script>
